import '@babel/polyfill'
import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store/index'
import VeeValidate from 'vee-validate'
import URLSearchParams from 'url-search-params'
import VueGtm from 'vue-gtm'
import * as Sentry from "@sentry/vue";

import { configData } from './helpers/getConfigData'

import 'bootstrap/dist/css/bootstrap.css'
import 'spin.js/spin.css'
import './assets/css/style.scss'

import { version } from '../package.json';

Vue.use(VeeValidate, {
    events: 'change'
})

Vue.use(VueGtm, {
    id: JSON.parse(process.env.VUE_APP_GTM_ID),
    elementId: 'gtm',
    nonceContainerId: 'xn-ct',
    nonceContainerAttribute: 'data-xn',
    vueRouter: router
})

if (process.env.VUE_APP_SENTRY_URL) {
    Sentry.init({
        Vue,
        dsn: process.env.VUE_APP_SENTRY_URL,
        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
        release: `payment-forms-frontend@${version}`,
        ignoreErrors: ['AxiosError'],
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration(),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [/^https:\/\/(dev-|dev-testcafe-|beta-|beta-testcafe-|testcafe-)?payments\.wiosna\.org\.pl/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

window.onload = function () {
    function createVue () {
        new Vue({
            el: '#app',
            router,
            store,
            render: h => h(App)
        })
    }

    const urlSearch = new URLSearchParams(window.location.search)
    let ver = urlSearch.get('ver')
    ver = (ver == null) ? '1' : ver

    configData.getConfigData(ver).then(data => {
        store.commit('setConfigData', data)
    }).catch(function (error) {
        store.commit('setConfigData', error.response)
    }).finally(function () {
        createVue()
    })
}
